/* eslint-disable camelcase */
import TransportationClient from '@/api/TransportationClient';

const defaultState = {
  promotions: {
    content: [],
  },
};

const mutations = {
  setPromotions(state, promotions) {
    state.promotions = promotions;
  },
};

const actions = {
  async getPromotions({ commit }) {
    const api = new TransportationClient();

    const { data } = await api.getPromotions();

    commit('setPromotions', data.data);
  },
};

const getters = {
  currentPromotions: (state) => () => state.promotions.content,
};

export default {
  state: defaultState,
  mutations,
  actions,
  getters,
};
